<script setup lang="ts">
import { AxialForm } from '@common';

import { useDecisionSupportWizardStore } from '../../stores/decision-support-wizard.store';
import { storeToRefs } from 'pinia';

const decisionSupportWizardStore = useDecisionSupportWizardStore();

const { getApplyForm } = storeToRefs(decisionSupportWizardStore);
</script>

<template>
  <div class="pa-6">
    <axial-form
      :form="getApplyForm.element"
      :disabled="false" />
  </div>
</template>
